import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'HelpListfilter'
  })
  export class HelpListPipe implements PipeTransform {
    transform(items: any[], searchText: string) {
        return items ? items.filter(item => item.popupDescription.search(new RegExp(searchText, 'i')) > -1) : [];
        }

  }